import React, { Component } from 'react';
import axios from 'axios';
import qs from 'qs';
import { Pie } from 'react-chartjs-2';
import { DateUtils } from 'react-day-picker';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import '../../daystyle.css';
// import './App.scss';
import '../../App.scss'
import Detaylist from '../../components/detaylist';
import Checkbox from '../../components/checkbox';
import Buttonsgroup from '../../components/buttonsgroup';
import DaypickerComponent from '../../components/daypickerinput';
import DaypickerComponent2 from '../../components/daypickerinputV2';
import istatistikObj from './istatistikObj';
import S from './style'
import DataTable from '../../components/datagrid/indexV2.js'
import { Row, Col, Space, Divider } from 'antd';
import Rakamlar from './pie/rakamlar'
import NewChart from './newChart'
class Istatistik extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apiUrl: "http://reportapi.bestbilgisayar.info/",
      from: false,
      to: false,
      detaylist: false,
      sonucfiltre: "Hepsi",
      chartData:false,
      checkboxes: [
        {
          checked: true,
          label: "Tümü",
          states: "all",
          res: "ALL"
        },
        {
          checked: false,
          label: "Swab",
          states: "swab",
          res: "SWAB"
        },
        {
          checked: false,
          label: "Kimyasal",
          states: "kimyasal",
          res: "KİMYASAL"
        },
        {
          checked: false,
          label: "Havuzsuyu",
          states: "havuzsuyu",
          res: "HAVUZSUYU"
        },
        {
          checked: false,
          label: "Havuzsuyu Mikrobiyoloji",
          states: "havuzsuyumikro",
          res: "H.SUYU MİKROBİYOLOJİ"
        },
        {
          checked: false,
          label: "Legionella",
          states: "legionella",
          res: "LEGİONELLA"
        },
        {
          checked: false,
          label: "Su Özel",
          states: "suozel",
          res: "SU-ÖZEL"
        },
        {
          checked: false,
          label: "Gıda",
          states: "gida",
          res: "GIDA"
        },
        {
          checked: false,
          label: "Ortam",
          states: "ortam",
          res: "ORTAM P."
        },
        {
          checked: false,
          label: "Mantar",
          states: "mantar",
          res: "MANTAR"
        },
        {
          checked: false,
          label: "Deniz Suyu",
          states: "denizsuyu",
          res: "D.SUYU MİK."
        },
        {
          checked: false,
          label: "Sıvı",
          states: "sivi",
          res: "SIVI"
        },
        {
          checked: false,
          label: "H.Suyu Mikro Kim.",
          states: "havuzsuyumikrokimyasal"
        },
      ],
    }
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.istatistikdegistir = this.istatistikdegistir.bind(this);
    this.istatistikdetay = this.istatistikdetay.bind(this);
    this.checker = this.checker.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.tofunc = this.tofunc.bind(this);
    this.detaylistsonuc = this.detaylistsonuc.bind(this);

    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.pdflebeni = this.pdflebeni.bind(this);
    this._baslangicTarihSet = this._baslangicTarihSet.bind(this);
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  detaylistsonuc(veri) {
    let filtre = this.state.sonucfiltre;
    let testarray = [];
    this.state.checkboxes.map((g) => {
      if (g.res === "ALL" && g.checked) {
        testarray = veri;
      } else {
        if (g.checked) {
          let filterarray = veri.filter(item => suzgecnumunetipi(item, g.res));
          let newarray = testarray.concat(filterarray);
          testarray = newarray;
        }
      }
      return true;
    })

    var kurumid = this.props.kuruminfo[0].Kod;
    var baslangictarihi = this.state.from.toLocaleDateString().split('.').reverse().join('-');
    var bitistarihi = this.state.to.toLocaleDateString().split('.').reverse().join('-');
    var url = 'http://reportapi.bestbilgisayar.info/kurum/istatistikdetay/';
    var data = qs.stringify({
      kurumid: kurumid,
      baslangictarihi: baslangictarihi,
      bitistarihi: bitistarihi
    });
    var config = {
      async: false,
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
        'Content-type': 'application/x-www-form-urlencoded'
      }
    };
    var self = this;
    switch (filtre) {
      case "Hepsi":
        let arryy1 = testarray.filter(item => suzgec(item, "Olumsuz"));

        this.setState({
          detaylist: arryy1,
          sonucfiltre: "Olumsuz"
        });
        break;
      case "Olumsuz":




        axios.post(url, data, config).then(function (response) {




          let arryy2 = response.data.filter(item => suzgec(item, "Olumlu"));
          let testarray = [];
          self.state.checkboxes.map((g) => {
            if (g.res === "ALL" && g.checked) {
              let arryy2 = response.data.filter(item => suzgec(item, "Olumlu"));
              testarray = arryy2;
            } else {
              if (g.checked) {
                let filterarray = arryy2.filter(item => suzgecnumunetipi(item, g.res));
                let newarray = testarray.concat(filterarray);
                testarray = newarray;
              }
            }
            return true;
          })
          self.setState({ detaylist: testarray, sonucfiltre: "Olumlu" });
        });
        break;
      case "Olumlu":
        axios.post(url, data, config).then(function (response) {





          let testarray = [];
          self.state.checkboxes.map((g) => {
            if (g.res === "ALL" && g.checked) {
              testarray = response.data;
              //return self.setState({detaylist:response.data,grafikdata:false});

            } else {
              if (g.checked) {
                let filterarray = response.data.filter(item => suzgecnumunetipi(item, g.res));
                let newarray = testarray.concat(filterarray);
                testarray = newarray;
              }
            }
            return true;
          })
          self.setState({ detaylist: testarray, sonucfiltre: "Hepsi" });
        });

        break;
      default:

    }
    function suzgec(item, durum) {
      if (item.SonucDurum === durum) {
        return true;
      }
      return false;
    }
    function suzgecnumunetipi(item, durum) {
      if (item.NumuneTipi === durum) {
        return true;
      }
      return false;
    }
  }
  tofunc(el) {
    this.to = el
  }
  focusTo() {
    // Focus to `to` field. A timeout is required here because the overlays
    // already set timeouts to work well with input fields
    this.timeout = setTimeout(() => this.to.getInput().focus(), 0);
  }
  showFromMonth() {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), 'months') < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  }
  handleFromChange(from, e) {
    // Change the from date and focus the "to" input field
    console.log(from)
    this.setState({ from }, () => {
      if (!this.state.to) {
        this.focusTo();
      }
    });
  }
  _baslangicTarihSet(values, e) {
    // Change the from date and focus the "to" input field
    console.log(values)
    this.setState({ from: values[0], to: values[1] })
    // this.setState({ from }, () => {
    //   if (!this.state.to) {
    //     this.focusTo();
    //   }
    // });
  }
  handleToChange(to) {
    console.log(to)
    this.setState({ to }, this.showFromMonth);
  }
  _bitisTarihSet(to) {
    console.log(to)
    this.setState({ to }, this.showFromMonth);
  }
  checker(e) {
    let { name, value } = e.target;

    this.setState((prevState) => {

      return (
        {
          checklist: {
            ...prevState.checklist,
            [name]: value
          }
        }
      )
    }
    );
  }
  toggleCheckbox(index) {
    const { checkboxes } = this.state;
    if (checkboxes[index].states === "all") {
      this.setState({
        checkboxes: [
          {
            checked: true,
            label: "Tümü",
            states: "all"
          },
          {
            checked: false,
            label: "Swab",
            states: "swab"
          },
          {
            checked: false,
            label: "Kimyasal",
            states: "kimyasal"
          },
          {
            checked: false,
            label: "Havuzsuyu",
            states: "havuzsuyu"
          },
          {
            checked: false,
            label: "Havuzsuyu Mikrobiyoloji",
            states: "havuzsuyumikro"
          },
          {
            checked: false,
            label: "Legionella",
            states: "legionella"
          },
          {
            checked: false,
            label: "Su Özel",
            states: "suozel"
          },
          {
            checked: false,
            label: "Gıda",
            states: "gida"
          },
          {
            checked: false,
            label: "Ortam",
            states: "ortam"
          },
          {
            checked: false,
            label: "Mantar",
            states: "mantar"
          },
          {
            checked: false,
            label: "Deniz Suyu",
            states: "denizsuyu"
          },
          {
            checked: false,
            label: "H.Suyu Mikro Kim.",
            states: "havuzsuyumikrokimyasal"
          },
        ],
      })
    } else {
      checkboxes[0].checked = false;
      checkboxes[index].checked = !checkboxes[index].checked;
      this.setState({
        checkboxes
      });
    }
    console.log(this.state.checkboxes)
    this.istatistikdegistir();
  }
  toggleCheckboxdetay(index) {
    const { checkboxes } = this.state;
    if (checkboxes[index].states === "all") {
      this.setState({
        checkboxes: [
          {
            checked: true,
            label: "Tümü",
            states: "all",
            res: "ALL"
          },
          {
            checked: false,
            label: "Swab",
            states: "swab",
            res: "SWAB"
          },
          {
            checked: false,
            label: "Kimyasal",
            states: "kimyasal",
            res: "KİMYASAL"
          },
          {
            checked: false,
            label: "Havuzsuyu",
            states: "havuzsuyu",
            res: "HAVUZSUYU"
          },
          {
            checked: false,
            label: "Havuzsuyu Mikrobiyoloji",
            states: "havuzsuyumikro",
            res: "H.SUYU MİKROBİYOLOJİ"
          },
          {
            checked: false,
            label: "Legionella",
            states: "legionella",
            res: "LEGİONELLA"
          },
          {
            checked: false,
            label: "Su Özel",
            states: "suozel",
            res: "SU-ÖZEL"
          },
          {
            checked: false,
            label: "Gıda",
            states: "gida",
            res: "GIDA"
          },
          {
            checked: false,
            label: "Ortam",
            states: "ortam",
            res: "ORTAM P."
          },
          {
            checked: false,
            label: "Mantar",
            states: "mantar",
            res: "MANTAR"
          },
          {
            checked: false,
            label: "Deniz Suyu",
            states: "denizsuyu",
            res: "D.SUYU MİK."
          },
          {
            checked: false,
            label: "H.Suyu Mikro Kim.",
            states: "havuzsuyumikrokimyasal"
          },
        ]
      })
    } else {
      checkboxes[0].checked = false;
      checkboxes[index].checked = !checkboxes[index].checked;
      this.setState({
        checkboxes
      });
    }
    this.istatistikdetay();
  }
  istatistikdegistir(e) {

    var kurumid = this.props.kuruminfo[0].Kod;
    var baslangictarihi = this.state.from.split('.').reverse().join('-');
    var bitistarihi = this.state.to.split('.').reverse().join('-');

    var url = 'http://reportapi.bestbilgisayar.info/kurum/istatistik/';
    var data = qs.stringify({
      kurumid: kurumid,
      baslangictarihi: baslangictarihi,
      bitistarihi: bitistarihi
    });
    var config = {
      async: false,
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
        'Content-type': 'application/x-www-form-urlencoded'
      }
    };
    var self = this;

    axios.post(url, data, config).then(function (response) {

      console.log(response)
      response.data.map((x) => {
        switch (x.NumuneTipi) {
          case "HAVUZSUYU":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[0].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[0].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[0].datasets[0].data[0] = 0
              istatistikObj[0].datasets[0].data[1] = 0
            }

            break;
          case "H.SUYU MİKROBİYOLOJİ":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[2].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[2].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[2].datasets[0].data[0] = 0
              istatistikObj[2].datasets[0].data[1] = 0
            }

            break;
          case "KİMYASAL":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[3].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[3].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[3].datasets[0].data[0] = 0
              istatistikObj[3].datasets[0].data[1] = 0
            }

            break;
          case "LEGİONELLA":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[4].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[4].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[4].datasets[0].data[0] = 0
              istatistikObj[4].datasets[0].data[1] = 0
            }

            break;
          case "SU-ÖZEL":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[5].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[5].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[5].datasets[0].data[0] = 0
              istatistikObj[5].datasets[0].data[1] = 0
            }

            break;
          case "SWAB":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[6].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[6].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[6].datasets[0].data[0] = 0
              istatistikObj[6].datasets[0].data[1] = 0
            }

            break;
          case "GIDA":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[1].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[1].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[1].datasets[0].data[0] = 0
              istatistikObj[1].datasets[0].data[1] = 0
            }

            break;
          case "MANTAR":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[7].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[7].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[7].datasets[0].data[0] = 0
              istatistikObj[7].datasets[0].data[1] = 0
            }

            break;
          case "ORTAM P.":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[8].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[8].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[8].datasets[0].data[0] = 0
              istatistikObj[8].datasets[0].data[1] = 0
            }

            break;
          case "D.SUYU MİK.":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[9].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[9].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[9].datasets[0].data[0] = 0
              istatistikObj[9].datasets[0].data[1] = 0
            }

            break;
          case "SIVI":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[10].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[10].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[10].datasets[0].data[0] = 0
              istatistikObj[10].datasets[0].data[1] = 0
            }

            break;
          case "H.SUYU MİKRO.KİM.":
            if (x.SonucDurum === "Olumlu") {
              istatistikObj[11].datasets[0].data[0] = x.Adet
            } else if (x.SonucDurum === "Olumsuz") {
              istatistikObj[11].datasets[0].data[1] = x.Adet
            } else {
              istatistikObj[11].datasets[0].data[0] = 0
              istatistikObj[11].datasets[0].data[1] = 0
            }

            break;
          default:

        }
        return true;
      })

      self.setState({
        grafikdata: istatistikObj,
        detaylist: false,
        chartData:response
      })
    });
  }
  istatistikdetay(e) {

    var kurumid = this.props.kuruminfo[0].Kod;
    var baslangictarihi = this.state.from.split('.').reverse().join('-');
    var bitistarihi = this.state.to.split('.').reverse().join('-');

    var url = 'http://reportapi.bestbilgisayar.info/kurum/istatistikdetay/';
    var data = qs.stringify({
      kurumid: kurumid,
      baslangictarihi: baslangictarihi,
      bitistarihi: bitistarihi
    });
    var config = {
      async: false,
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ=',
        'Content-type': 'application/x-www-form-urlencoded'
      }
    };
    var self = this;

    axios.post(url, data, config).then(function (response) {
      let testarray = [];
      self.state.checkboxes.map((g) => {
        if (g.res === "ALL" && g.checked) {
          console.log("Hepsi")
          testarray = response.data;
          console.log(testarray)
          //return self.setState({detaylist:response.data,grafikdata:false});

        } else {
          if (g.checked) {
            let filterarray = response.data.filter(item => suzgecnumunetipi(item, g.res));
            let newarray = testarray.concat(filterarray);
            testarray = newarray;
          }
        }
        return true;
      })

      return testarray;
    }).then((result) => {
      console.log(result);
      self.setState({ detaylist: result, grafikdata: false, sonucfiltre: "Hepsi" });
    });
    function suzgecnumunetipi(item, durum) {
      if (item.NumuneTipi === durum) {
        return true;
      }
      return false;
    }
  }
  getInitialState() {
    return {
      from: undefined,
      to: undefined,
      grafikdata: undefined,
      detaylist: false
    };
  }
  handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range);
  }
  handleResetClick() {
    this.setState(this.getInitialState());
  }
  pdflebeni() {
    var doc = new jsPDF('landscape');

    let element = document.getElementById("content");
    html2canvas(element).then(function (canvas) {
      var canv = canvas;
      var dataURL = canv.toDataURL();
      doc.addImage(dataURL, 'JPEG', 25, 0);
      doc.save("istatistik.pdf");
      //document.body.appendChild(canvas);
    });
  }
  render() {
    const that = this;
    const { from, to } = this.state;
    return (
      <S.Wrapper>
        <Row justify="center">
          <Col span={6}><DaypickerComponent2 {...that} /></Col>
          {(to) ? (<Col span={5}>
            <Buttonsgroup
              degistir={this.istatistikdegistir}
              detay={this.istatistikdetay}
              reset={this.handleResetClick}
              pdf={this.pdflebeni}
              disable={this.state.grafikdata || this.state.detaylist ? false : true}
            /></Col>
          ) : false}
        </Row>
        <Divider />
        <S.Head >

          <div className="filterItems">
            {this.state.grafikdata ? this.state.checkboxes.map((x, i) => {
              return <Checkbox key={i} label={x.label} checked={x.checked} value={x.states} name={x.states} evt={() => this.toggleCheckbox(i)} />
            }) : false}

            {this.state.detaylist ? this.state.checkboxes.map((x, i) => {
              return <Checkbox key={i} label={x.label} checked={x.checked} value={x.states} name={x.states} evt={() => this.toggleCheckboxdetay(i)} />
            }) : false}

          </div>
        </S.Head>
        <S.Content id="content">
          <div className="data">
            {this.state.checkboxes.map((y) => {
              if (y.states === "all" && y.checked) {
                if (this.state.grafikdata) {
                  return <NewChart data ={this.state.chartData}/>
                  // let begin = this.state.grafikdata.map((x, i) => {
                  //   if (x.datasets[0].data[0] > 0 || x.datasets[0].data[1] > 0) {

                  //     return (<>
                  //     <S.PieWrap key={i}>
                  //       <div style={{ width: '100%', textAlign: 'center' }}>{x.name}</div>
                  //       <Pie
                  //         key={i}
                  //         data={x}
                  //         width={100}
                  //         height={50}
                  //         options={{
                  //           maintainAspectRatio: true
                  //         }}
                  //       />
                  //       <Rakamlar data={x.datasets[0].data} />
                  //     </S.PieWrap></>)
                  //   } else {
                  //     return false
                  //   }
                  // })
                  // return begin;
                }
              } else {
                if (this.state.grafikdata) {
                  let begin = this.state.grafikdata.map((x, i) => {
                    if (x.datasets[0].data[0] > 0 || x.datasets[0].data[1] > 0) {

                      let layout;
                      if (x.statename === y.states && y.checked === true) {
                        layout = (<S.PieWrap key={i}>
                          <div style={{ width: '100%', textAlign: 'center' }}>{x.name}</div>
                          <Pie
                            key={i}
                            data={x}
                            width={100}
                            height={50}
                            options={{
                              maintainAspectRatio: true
                            }}
                          />
                          <Rakamlar data={x.datasets[0].data} />
                        </S.PieWrap>)
                        return layout;
                      }
                      return layout
                    } else {
                      return false
                    }
                  })
                  return begin;
                }
              }
              return true;
            })
            }
          </div>
          {this.state.detaylist ? <DataTable data={this.state.detaylist || false} /> : false}

        </S.Content>
      </S.Wrapper>
    );
  }
}
export default Istatistik;
